import * as React from 'react';
import type { SVGProps } from 'react';
const SvgArrowSubmit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4.167 10h11.667M10 4.164l5.833 5.833L10 15.831"
    />
  </svg>
);
export default SvgArrowSubmit;
